import { render, staticRenderFns } from "./MonthlyUserStatistics.vue?vue&type=template&id=5a2c43b3&"
import script from "./MonthlyUserStatistics.vue?vue&type=script&lang=js&"
export * from "./MonthlyUserStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports